import { Mutation } from 'react-apollo'
import createLoan, {
  CreateLoan,
  CreateLoanInput
} from '../../graphql/mutations/createLoan'
import withMutation from './withMutation'

class CreateLoanMutation extends Mutation<CreateLoan, CreateLoanInput> {}

export default withMutation(createLoan)(CreateLoanMutation)



// WEBPACK FOOTER //
// ./src/components/mutations/CreateLoanMutation.tsx